// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

export enum CheckContentShareConnectivityFeedback {
  Succeeded,
  Failed,
  PermissionDenied,
  TimedOut,
  ConnectionFailed,
}

export default CheckContentShareConnectivityFeedback;
